import d3Legacy from 'd3-legacy';
import _each from 'lodash/each';
import _ceil from 'lodash/ceil';
import _map from 'lodash/map';
import _floor from 'lodash/floor';
import _flatten from 'lodash/flatten';
import moment from 'moment';
import clearNodeChildren from 'js/helpers/clearNodeChildren';
import { getCurrentD3Locale } from 'js/helpers/dateTimeAndNumberFormatting';
import { plot_config } from './config';
export function formatXAxisDate(d) {
  var date = getCurrentD3Locale().timeFormat('%b %y')(d);
  return date;
}
export function format(obj, color) {
  var main = {};
  main.tag = obj.tag;
  main._id = obj._id;
  main.values = [];
  main.unit = obj.unit;
  main.color = obj.color ? obj.color : color;
  main.title = obj.title; // eslint-disable-next-line no-unused-expressions

  obj.values ? obj.values.map(function (b) {
    var date = new Date(b.x);
    var value = b.y;
    var result = {
      x: date,
      y: value
    };
    main.values.push(result);
    return result;
  }) : main.values = undefined;
  return main;
}
export function filterData(data, self, checkboxState) {
  var newData = [];
  data.map(function (a) {
    if (!checkboxState[a._id] || checkboxState[a._id].show) {
      newData.push(format(a));
    }

    if (a.idx1) {
      a.idx1.map(function (b) {
        if (!checkboxState[b._id] || checkboxState[b._id].show) {
          newData.push(format(b, a.color));
        }

        if (b.idx2) {
          b.idx2.map(function (c) {
            if (!checkboxState[c._id] || checkboxState[c._id].show) {
              newData.push(format(c, a.color));
            }

            if (c.idx3) {
              c.idx3.map(function (d) {
                if (!checkboxState[d._id] || checkboxState[d._id].show) {
                  newData.push(format(d, a.color));
                }
              });
            }
          });
        }
      });
    }
  });
  return newData;
}
export function initializePlot(datax, props, self) {
  var data = filterData(datax, self, props.checkboxState);
  if (data && !data.length) return clearNodeChildren(document.getElementById(props.plotID));
  data = data.filter(function (k) {
    return k.values !== undefined;
  });
  clearNodeChildren(document.getElementById(props.plotID)); // Set the dimensions of the canvas / graph

  var totalWidth = props.windowWidth;
  var margin = {
    top: 50,
    right: 5,
    bottom: 70,
    left: 30
  };
  var marginBrush = {
    top: 520,
    bottom: 20,
    left: 30
  };
  var width = (totalWidth - margin.left - margin.right) * 0.7; // pantalla mediana

  var height = plot_config.PRICE_GRAPH_TOTAL_HEIGHT - margin.top - margin.bottom;
  var heightBrush = plot_config.PRICE_GRAPH_TOTAL_HEIGHT - marginBrush.top - marginBrush.bottom;
  if (data && !data.length) return;

  var allDates = _flatten(_map(data, function (d) {
    return _map(d.values, 'x');
  }));

  var allValues = _flatten(_map(data, function (d) {
    return _map(d.values, 'y');
  })); // Set the ranges


  var xDomain = d3Legacy.extent(allDates); // self.setState({ xDomain }); // redux

  var x = d3Legacy.time.scale().domain(xDomain).range([0, width]);
  var xBrush = d3Legacy.time.scale().domain(xDomain).range([0, width]);
  var yDomain = [0, d3Legacy.max(allValues)];
  var y = d3Legacy.scale.linear().domain(yDomain).range([height, 0]);
  var bisectDate = d3Legacy.bisector(function (d) {
    return d.x;
  }).left; // Define the axes

  var MAX_NUMBER_OF_X_TICKS = _floor(totalWidth / 80); // Based on 12 ticks for 960px - easily changed


  var xAxis = d3Legacy.svg.axis().scale(x).orient('bottom').ticks(getXTicks).tickFormat(formatXAxisDate).outerTickSize(0);
  var xAxisBrush = d3Legacy.svg.axis().scale(xBrush).orient('bottom').ticks(getXTicks).tickFormat(formatXAxisDate).outerTickSize(0);
  var yAxis = d3Legacy.svg.axis().scale(y).orient('left').ticks(plot_config.NUMBER_OF_Y_TICKS).outerTickSize(0);
  var brush = d3Legacy.svg.brush().x(xBrush).extent(xDomain).on('brush', onBrush); // Define the line

  var priceLine = d3Legacy.svg.line().x(function (d) {
    return x(d.x);
  }).y(function (d) {
    return y(d.y);
  }); // Adds the svg canvas

  var svg = d3Legacy.select("#".concat(props.plotID)).append('svg').attr('class', 'cosmos-svg--with-overflow').attr('width', totalWidth).attr('height', plot_config.PRICE_GRAPH_TOTAL_HEIGHT);
  svg.append('defs').append('clipPath').attr('id', 'clip-spot-user').append('rect').attr('width', width).attr('height', height);
  var focus = svg.append('g').attr('transform', "translate(".concat(margin.left, ",").concat(margin.top, ")"));
  var context = svg.append('g').attr('transform', "translate(".concat(marginBrush.left, ",").concat(marginBrush.top, ")"));
  var focuslineGroups = focus.selectAll('g').data(data).enter().append('g');
  focuslineGroups.append('path').attr('class', 'cosmos-line').attr('d', function (d) {
    return priceLine(d.values);
  }).style('stroke', function (d) {
    return d.color ? d.color : '#606060';
  }).attr('clip-path', 'url(#clip-spot-user)'); // Brush elements

  context.append('g').attr('class', 'cosmos-axis cosmos-axis--x').attr('transform', "translate(0,".concat(heightBrush, ")")).call(xAxisBrush);
  var brushElement = context.append('g').attr('class', 'cosmos-brush cosmos-brush--x').call(brush);
  brushElement.selectAll('rect').attr('y', -6).attr('height', heightBrush + 7);
  brushElement.selectAll('.background').style('visibility', 'visible').attr('rx', 3).attr('ry', 3);
  var resizeWSvg = brushElement.selectAll('.resize.w').append('svg').attr('x', '-50%').attr('y', -7).attr('height', 19).attr('viewBox', '0 0 44 44');
  var wLineG = resizeWSvg.append('g');
  wLineG.append('path').attr('class', 'cosmos-svg__st0').attr('d', 'M12,43C5.9,43,1,38.1,1,32V12C1,5.9,5.9,1,12,1h31v42H12z');
  wLineG.append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M42,2v40H12C6.5,42,2,37.5,2,32V12C2,6.5,6.5,2,12,2H42 M44,0h-2H12C5.4,0,0,5.4,0,12v20c0,6.6,5.4,12,12,12h30h2v-2V2V0L44,0z');
  resizeWSvg.append('g').append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M28.8,32L28.8,32c-0.6,0-1-0.4-1-1V13c0-0.6,0.4-1,1-1h0c0.6,0,1,0.4,1,1v18C29.8,31.6,29.3,32,28.8,32z');
  resizeWSvg.append('g').append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M19,32L19,32c-0.6,0-1-0.4-1-1V13c0-0.6,0.4-1,1-1h0c0.6,0,1,0.4,1,1v18C20,31.6,19.6,32,19,32z');
  var resizeESvg = brushElement.selectAll('.resize.e').append('svg').attr('x', '-50%').attr('y', -7).attr('height', 19).attr('viewBox', '0 0 44 44');
  var eLineG = resizeESvg.append('g');
  eLineG.append('path').attr('class', 'cosmos-svg__st0').attr('d', 'M1,43V1h31c6.1,0,11,4.9,11,11v20c0,6.1-4.9,11-11,11H1z');
  eLineG.append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M32,2c5.5,0,10,4.5,10,10v20c0,5.5-4.5,10-10,10H2V2H32 M32,0H2H0v2v40v2h2h30c6.6,0,12-5.4,12-12V12C44,5.4,38.6,0,32,0L32,0z');
  resizeESvg.append('g').append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M15.2,12L15.2,12c0.6,0,1,0.4,1,1v18c0,0.6-0.4,1-1,1h0c-0.6,0-1-0.4-1-1V13C14.2,12.4,14.7,12,15.2,12z');
  resizeESvg.append('g').append('path').attr('class', 'cosmos-svg__st1').attr('d', 'M25,12L25,12c0.6,0,1,0.4,1,1v18c0,0.6-0.4,1-1,1h0c-0.6,0-1-0.4-1-1V13C24,12.4,24.4,12,25,12z'); // Axes

  var xAxisElement = focus.append('g').attr('class', 'cosmos-axis cosmos-axis--x').attr('transform', "translate(0,".concat(height, ")")).call(xAxis);
  var yAxisElement = focus.append('g').attr('class', 'cosmos-axis cosmos-axis--y').call(yAxis);
  yAxisElement.append('text').attr('transform', 'rotate(-90)').attr('class', 'cosmos-axis__label').attr('x', plot_config.Y_AXIS_LABEL_X).attr('y', plot_config.Y_AXIS_LABEL_Y).text(plot_config.Y_AXIS_LABEL); // Graph hover elements

  var xCrossHair = svg.append('line').attr('id', 'x-crosshair').attr('class', 'cosmos-crosshair').attr('display', 'none');
  var hoverDate = svg.append('g').attr('display', 'none');
  var hoverDateBox = hoverDate.append('rect').attr('rx', 5).attr('ry', 5).attr('class', 'cosmos-date-box');
  var hoverDateText = hoverDate.append('text').attr('dy', -plot_config.HOVER_DATE_TOP_BOTTOM_PADDING).attr('text-anchor', 'middle');
  var nodeElements = {};

  _each(data, function (d, i) {
    var color = d.color ? d.color : '#606060';
    appendNode(plot_config.SURROUNDING_NODE_SIZE, d.tag, i, plot_config.PREVIOUS, color);
    appendNode(plot_config.SURROUNDING_NODE_SIZE, d.tag, i, plot_config.NEXT, color);
    appendNode(plot_config.MAIN_NODE_SIZE, d.tag, i, plot_config.CURRENT, color);
  });

  svg.append('rect').attr('class', 'cosmos-overlay').attr('width', width).attr('height', height).attr('transform', "translate(".concat(margin.left, ",").concat(margin.top, ")")).on('mouseout', onMouseOut).on('mouseover', onMouseMoveOver).on('mousemove', onMouseMoveOver); // TODO: self is ugly

  function updateCurrentRangeExternally(externalExtent) {
    brush.extent(externalExtent);
    brushElement.transition().duration(0).call(brush);
    x.domain(brush.empty() ? xDomain : brush.extent());
    focus.selectAll('path.cosmos-line').attr('d', function (d) {
      return priceLine(d.values);
    });
    xAxisElement.call(xAxis);
    yAxisElement.call(yAxis);
  }

  function getXTicks(startDate, endDate) {
    if (!data.length) return;
    var currentIndex = bisectDate(data[0].values, startDate);
    var currentDataPoint = data[0].values[currentIndex];
    var dateTicks = [];

    var incrementBy = _ceil(data[0].values.length / MAX_NUMBER_OF_X_TICKS);

    while (currentDataPoint && new Date(currentDataPoint.x).getTime() <= endDate.getTime()) {
      dateTicks.push(new Date(currentDataPoint.x));
      currentIndex += incrementBy;
      currentDataPoint = data[0].values[currentIndex];
    }

    return dateTicks;
  }

  function onBrush() {
    if (!data.length) return; // Hide interactive elements on brush - useful for mobile

    onMouseOut();
    if (!d3Legacy.event.sourceEvent) return; // only transition after input

    var brushExtent = brush.extent();
    var extentStartIndex = bisectDate(data[0].values, brushExtent[0]);
    var extentEndIndex = bisectDate(data[0].values, brushExtent[1]); // Require at least two data points

    if (extentStartIndex === extentEndIndex && data[0].values[extentEndIndex + 1]) {
      extentEndIndex++;
    } else if (extentStartIndex === extentEndIndex && data[0].values[extentStartIndex - 1]) {
      extentStartIndex--;
    }

    var currentRange = [moment(new Date(data[0].values[extentStartIndex].x)), moment(new Date(data[0].values[extentEndIndex].x))];
    brush.extent(currentRange);
    d3Legacy.select(self).transition().duration(0).call(brush.event);
    x.domain(brush.empty() ? xDomain : brush.extent());
    focus.selectAll('path.cosmos-line').attr('d', function (d) {
      return priceLine(d.values);
    });
    xAxisElement.call(xAxis);
    yAxisElement.call(yAxis);
    props.actions.setCurrentDateRange(props.countryID, props.plotID, currentRange);
  }

  function constructNodeString(collectionIndex, prevNextCurrent) {
    return collectionIndex + prevNextCurrent;
  }

  function appendNode(nodeSize, collectionKey, collectionIndex, prevNextCurrent, color) {
    var nodeString = constructNodeString(collectionIndex, prevNextCurrent);
    nodeElements[nodeString] = svg.append('g').attr('class', "cosmos-focus-node cosmos-focus-node--".concat(nodeString)).attr('display', 'none');
    nodeElements[nodeString].append('circle').attr('fill', color).attr('stroke', color).attr('r', nodeSize);
    if (prevNextCurrent !== plot_config.CURRENT) return;
    nodeElements[nodeString].append('rect').attr('class', 'cosmos-focus-node__tooltip').attr('stroke', color).attr('rx', '5px').attr('ry', '5px');
    nodeElements[nodeString].append('text').attr('class', 'cosmos-focus-node__tooltip-text');
  }

  function positionAndShowNode(dataPoint, prevNextCurrent, d, i) {
    if (!dataPoint) return;
    var nodeElement = nodeElements[constructNodeString(i, prevNextCurrent)];
    if (!nodeElement || x(dataPoint.x) < 0 || x(dataPoint.x) > width || y(dataPoint.y) < 0 || y(dataPoint.y) > height) return;
    var nodePositionX = margin.left + x(dataPoint.x);
    var nodePositionY = margin.top + y(dataPoint.y);
    nodeElement.attr('transform', "translate(".concat(nodePositionX, ",").concat(nodePositionY, ")")).attr('display', null);
    if (prevNextCurrent !== plot_config.CURRENT) return;
    var nodeText = nodeElement.select('text');
    var nodeRect = nodeElement.select('rect');
    var constructedNodeText = ["".concat(d.tag, ": "), d.unit === '$' ? "".concat(d.unit).concat(dataPoint.y) : "".concat(dataPoint.y, " ").concat(d.unit)].join('');
    nodeText.style('text-anchor', 'end').attr('x', -plot_config.TOOLTIP_X_MARGIN).attr('y', plot_config.TOOLTIP_Y_MARGIN).text(constructedNodeText);
    var textBBox = nodeText[0][0].getBBox();

    if (nodePositionX < width / 2) {
      nodeText.style('text-anchor', 'start').attr('x', plot_config.TOOLTIP_X_MARGIN);
      textBBox = nodeText[0][0].getBBox();
    }

    nodeRect.attr('width', textBBox.width + plot_config.TOOLTIP_SIDE_PADDING * 2).attr('height', textBBox.height + plot_config.TOOLTIP_TOP_BOTTOM_PADDING * 2).attr('x', textBBox.x - plot_config.TOOLTIP_SIDE_PADDING).attr('y', textBBox.y - plot_config.TOOLTIP_TOP_BOTTOM_PADDING);
  }

  function positionAndShowXCrossHair(xPosition) {
    if (xPosition < 0 || xPosition > width) return;
    xCrossHair.attr('x1', margin.left + xPosition).attr('y1', margin.top + y(yDomain[0])).attr('x2', margin.left + xPosition).attr('y2', margin.top + plot_config.HOVER_DATE_TOP_MARGIN + y(yDomain[1])).attr('display', null);
  }

  function positionAndShowHoverDate(currentDate) {
    if (x(currentDate) < 0 || x(currentDate) > width) return;
    hoverDate.attr('transform', "translate(".concat(margin.left + x(currentDate), ",").concat(margin.top + plot_config.HOVER_DATE_TOP_MARGIN + y(yDomain[1]), ")"));
    hoverDate.attr('display', null);
    hoverDateText.text(formatXAxisDate(currentDate));
    var textBBox = hoverDateText[0][0].getBBox();
    hoverDateBox.attr('height', textBBox.height + 2 * plot_config.HOVER_DATE_TOP_BOTTOM_PADDING).attr('width', textBBox.width + 2 * plot_config.HOVER_DATE_SIDE_PADDING).attr('y', textBBox.y - plot_config.HOVER_DATE_TOP_BOTTOM_PADDING).attr('x', textBBox.x - plot_config.HOVER_DATE_SIDE_PADDING);
  }

  function hideNodeElements() {
    _each(nodeElements, function (element) {
      element.attr('display', 'none');
    });
  }

  function hideXCrossHair() {
    xCrossHair.attr('display', 'none');
  }

  function hideHoverDate() {
    hoverDate.attr('display', 'none');
  }

  function onMouseOut() {
    hideNodeElements();
    hideXCrossHair();
    hideHoverDate();
  }

  function onMouseMoveOver() {
    if (!data.length) return; // Hide all of the elements in case they don't get redrawn

    onMouseOut();
    var closestDate = x.invert(d3Legacy.mouse(this)[0]);

    _each(data, function (d, i) {
      var index = bisectDate(d.values, closestDate);

      if (i === 0) {
        positionAndShowXCrossHair(x(d.values[index].x));
        positionAndShowHoverDate(d.values[index].x);
      }

      positionAndShowNode(d.values[index - 5], plot_config.PREVIOUS, d, i);
      positionAndShowNode(d.values[index + 5], plot_config.NEXT, d, i);
      positionAndShowNode(d.values[index], plot_config.CURRENT, d, i);
    });
  }

  var range = {
    total: [moment(xDomain[0]), moment(xDomain[1])],
    update: updateCurrentRangeExternally
  };
  return range;
}